import React from "react";
import {
  createBrowserRouter,
  Navigate,
  RouterProvider,
} from "react-router-dom";
import Layout from "./components/layout";
import { WithAdminAccess } from "./components/wrapper/admin";
import {
  AddDomain,
  AddNewProject,
  AllFolders,
  AllPages,
  CompleteStep,
  CreateTemplate,
  DomainSetup,
  EditCategory,
  EditProject,
  EditTemplateCategory,
  FolderPage,
  GetQRCode,
  NewCategory,
  NewFolder,
  NewTemplateCategory,
  PageBlocker,
  PageCategory,
  PageSettings,
  Payment,
  Profile,
  ProjectPage,
  Projects,
  ShadedPages,
  ShareSettings,
  ShowCategory,
  ShowTemplate,
  ShowTemplateCategory,
  Statistics,
  SuccessfulPayment,
  Support,
  TemplateCategory,
  Templates,
  UpdateTemplate,
  UserAdministration,
} from "./pages";
import { SubpageTemplates } from "./pages/subpageTemplates";
import { CreateForm } from "./pages/subpageTemplates/createForm";
import { EditForm } from "./pages/subpageTemplates/editForm";

const routes = (locale: string | undefined = "") => [
  {
    path: `/${locale}`,
    element: <Layout />,
    children: [
      { path: "", element: <Navigate to="projects" replace /> },
      {
        path: "payment",
        element: <Payment />,
      },
      {
        path: "payment/successful",
        element: <SuccessfulPayment />,
      },
      {
        path: "projects",
        element: <Projects />,
      },
      {
        path: "projects/new",
        element: <AddNewProject />,
      },
      {
        path: "projects/new/:projectId/setup",
        element: <DomainSetup />,
      },
      {
        path: "projects/new/:projectId/complete",
        element: <CompleteStep />,
      },
      {
        path: "projects/:id/add-domain",
        element: <AddDomain />,
      },
      {
        path: "projects/:id/add-subdomain",
        element: <AddDomain />,
      },
      {
        path: "projects/:projectId/edit",
        element: <EditProject />,
      },
      {
        path: "projects/:projectId",
        element: <ProjectPage />,
      },
      {
        path: "profile",
        element: <Profile />,
      },
      {
        path: "page/:id/edit",
        element: <PageSettings />,
      },
      {
        path: "page/create",
        element: <PageSettings />,
      },
      {
        path: "projects/:projectId/folder/:id",
        element: <FolderPage />,
      },
      {
        path: "folder/new",
        element: <NewFolder />,
      },
      {
        path: "user/access/:item/:id/access",
        element: <ShareSettings />,
      },
      {
        path: "page/category",
        element: (
          <WithAdminAccess>
            <PageCategory />
          </WithAdminAccess>
        ),
      },
      {
        path: "page/category/new",
        element: (
          <WithAdminAccess>
            <NewCategory />
          </WithAdminAccess>
        ),
      },
      {
        path: "page/category/:categoryId/edit",
        element: (
          <WithAdminAccess>
            <EditCategory />
          </WithAdminAccess>
        ),
      },
      {
        path: "page/category/:categoryId",
        element: (
          <WithAdminAccess>
            <ShowCategory />
          </WithAdminAccess>
        ),
      },
      {
        path: "template",
        element: (
          <WithAdminAccess>
            <Templates />
          </WithAdminAccess>
        ),
      },
      {
        path: "template/new",
        element: (
          <WithAdminAccess>
            <CreateTemplate />
          </WithAdminAccess>
        ),
      },
      {
        path: "template/:templateId/edit",
        element: (
          <WithAdminAccess>
            <UpdateTemplate />
          </WithAdminAccess>
        ),
      },
      {
        path: "template/:templateId",
        element: (
          <WithAdminAccess>
            <ShowTemplate />
          </WithAdminAccess>
        ),
      },
      {
        path: "template/category",
        element: (
          <WithAdminAccess>
            <TemplateCategory />
          </WithAdminAccess>
        ),
      },
      {
        path: "template/category/new",
        element: (
          <WithAdminAccess>
            <NewTemplateCategory />
          </WithAdminAccess>
        ),
      },
      {
        path: "template/category/:categoryId",
        element: (
          <WithAdminAccess>
            <ShowTemplateCategory />
          </WithAdminAccess>
        ),
      },
      {
        path: "template/category/:categoryId/edit",
        element: (
          <WithAdminAccess>
            <EditTemplateCategory />
          </WithAdminAccess>
        ),
      },
      {
        path: "shared",
        element: <ShadedPages />,
      },
      {
        path: "support",
        element: <Support />,
      },
      {
        path: "entry/:pageId",
        element: <GetQRCode />,
      },
      {
        path: "statistic-dashboard",
        element: <Statistics />,
      },
      {
        path: "statistic-dashboard/:pageId",
        element: <Statistics />,
      },
      {
        path: "page/all",
        element: (
          <WithAdminAccess>
            <AllPages />
          </WithAdminAccess>
        ),
      },
      {
        path: "folder/all",
        element: (
          <WithAdminAccess>
            <AllFolders />
          </WithAdminAccess>
        ),
      },
      {
        path: "user-administration",
        element: (
          <WithAdminAccess>
            <UserAdministration />
          </WithAdminAccess>
        ),
      },
      {
        path: "page-blocker",
        element: (
          <WithAdminAccess>
            <PageBlocker />
          </WithAdminAccess>
        ),
      },
      {
        path: "subpage-templates",
        element: (
          <WithAdminAccess>
            <SubpageTemplates />
          </WithAdminAccess>
        ),
      },
      {
        path: "subpage-templates/create",
        element: (
          <WithAdminAccess>
            <CreateForm />
          </WithAdminAccess>
        ),
      },
      {
        path: "subpage-templates/:templateId/edit",
        element: (
          <WithAdminAccess>
            <EditForm />
          </WithAdminAccess>
        ),
      },
    ],
  },
];

const router = createBrowserRouter([...routes(), ...routes(":locale")]);

function App() {
  return <RouterProvider router={router} />;
}

export default App;
